const scripts = {}
let phoneInput

function loadScript (src) {
  if (!scripts[src]) {
    scripts[src] = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = src
      script.async = true
      script.onload = resolve
      script.onerror = () => {
        script.remove()
        delete scripts[src]
        reject(new Error(`Cannot load ${src}`))
      }
      document.head.appendChild(script)
    })
  }
  return scripts[src]
}

function loadPhoneStyles () {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = '/assets/lib/css/intlTelInput.min.css'
    link.onload = resolve
    link.onerror = () => {
      link.remove()
      reject(new Error('Cannot load telephone styles'))
    }
    document.head.appendChild(link)
  })
}

export function loadPhoneInput () {
  if (!phoneInput) {
    phoneInput = Promise.all([
      loadPhoneStyles(),
      loadScript('/assets/lib/js/intlTelInput.min.js')
        .then(() => loadScript('/assets/lib/js/utils.js'))
    ]).catch(error => {
      phoneInput = null
      throw error
    })
  }
  return phoneInput
}

export function loadFormModal () {
  return loadScript('/phone_supplement/hystmodal.min.js')
}
